<template>
  <div v-if="showAny" class="social-auth">
    <div class="social-auth__divider"><span>{{ divider }}</span></div>
    <div class="social-auth__buttons">
      <button
        v-if="providers.google"
        type="button"
        class="social-auth__btn social-auth__btn--google"
        @click="start('google')"
      >
        <i class="mdi mdi-google"></i>
        Google
      </button>
      <button
        v-if="providers.yandex"
        type="button"
        class="social-auth__btn social-auth__btn--yandex"
        @click="start('yandex')"
      >
        <i class="mdi mdi-account-circle-outline"></i>
        Яндекс
      </button>
    </div>
  </div>
</template>

<script>
import { getSocialProviders, socialRedirectUrl } from '@/api/auth'

export default {
  name: 'SocialAuthButtons',
  props: {
    divider: {
      type: String,
      default: 'или',
    },
  },
  data() {
    return {
      providers: {
        google: false,
        yandex: false,
      },
    }
  },
  computed: {
    showAny() {
      return !!(this.providers.google || this.providers.yandex)
    },
  },
  mounted() {
    this.load()
  },
  methods: {
    async load() {
      try {
        const data = await getSocialProviders()
        this.providers = {
          google: !!(data && data.google),
          yandex: !!(data && data.yandex),
        }
      } catch (error) {
        this.providers = { google: false, yandex: false }
      }
    },
    start(provider) {
      window.location.href = socialRedirectUrl(provider)
    },
  },
}
</script>

<style scoped>
.social-auth {
  margin-top: 18px;
}

.social-auth__divider {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 14px;
  color: #8a97ab;
  font-size: 13px;
}

.social-auth__divider::before,
.social-auth__divider::after {
  content: '';
  flex: 1;
  height: 1px;
  background: #d9e2ec;
}

.social-auth__buttons {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
}

.social-auth__btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-height: 44px;
  border: 1px solid #d9e2ec;
  border-radius: 12px;
  background: #fff;
  color: #152033;
  font-weight: 650;
  cursor: pointer;
}

.social-auth__btn--google:hover {
  border-color: #4285f4;
  color: #1a73e8;
}

.social-auth__btn--yandex:hover {
  border-color: #fc3f1d;
  color: #fc3f1d;
}

@media (max-width: 480px) {
  .social-auth__buttons {
    grid-template-columns: 1fr;
  }
}
</style>
